import { Calendar, Clock, MapPin } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import type { EventoDetalhe, EventoStats } from '../types'
import { formatDate, formatTime } from '../utils'

interface EventOverviewCardProps {
  evento: EventoDetalhe
  stats: EventoStats
}

export function EventOverviewCard({ evento, stats }: EventOverviewCardProps) {
  const fimEm = evento.fim_em

  return (
    <Card>
      <CardHeader className="space-y-1">
        <CardTitle className="flex items-center gap-2 text-xl">
          <Calendar className="h-5 w-5 text-primary" />
          Detalhes do Evento
        </CardTitle>
        <CardDescription>Informações principais e cronograma</CardDescription>
      </CardHeader>
      <CardContent className="grid gap-6 md:grid-cols-2">
        <div className="space-y-4">
          <div>
            <p className="text-sm font-medium text-muted-foreground">Início</p>
            <p className="text-base font-semibold">{formatDate(evento.inicio_em, true)}</p>
          </div>
          <div>
            <p className="text-sm font-medium text-muted-foreground">Término</p>
            <p className="text-base font-semibold">
              {fimEm ? formatDate(fimEm, true) : 'A definir'}
            </p>
          </div>
          <div className="flex items-center gap-2 rounded-lg bg-muted p-3 text-sm text-muted-foreground">
            <Clock className="h-4 w-4 text-primary" />
            <span>
              Duração prevista: {formatTime(evento.inicio_em)} -{' '}
              {fimEm ? formatTime(fimEm) : '--:--'}
            </span>
          </div>
        </div>

        <div className="space-y-4">
          {evento.local && (
            <div className="flex items-start gap-3 rounded-lg border p-3">
              <div className="rounded-md bg-primary/10 p-2">
                <MapPin className="h-4 w-4 text-primary" />
              </div>
              <div>
                <p className="text-sm font-medium">Local</p>
                <p className="text-sm text-muted-foreground">{evento.local}</p>
              </div>
            </div>
          )}
          {evento.descricao && (
            <div>
              <p className="text-sm font-medium">Descrição</p>
              <p className="text-sm text-muted-foreground">{evento.descricao}</p>
            </div>
          )}
          {evento.capacidade && (
            <div className="rounded-lg bg-primary/5 p-3 text-sm space-y-1">
              <p className="font-medium text-primary">
                Capacidade total: {evento.capacidade} vagas
              </p>
              {stats.ocupacao !== null && (
                <>
                  <p className="text-muted-foreground">
                    Ocupação atual: {stats.total}/{evento.capacidade} ({stats.ocupacao.toFixed(1)}%)
                  </p>
                  <p className="font-medium text-emerald-600">
                    Vagas disponíveis: {evento.capacidade - stats.total}
                  </p>
                </>
              )}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
